/**  
 * @name: 定义后端返回code的值
 * @author:liufupeng
*/

export const STATUS = {
    success: "000000"
}
